import { useQuery } from "@tanstack/react-query";

import { useApplication } from "@olist/microfrontend";

import { TicketQueryKeys } from "./queryKeys";
import { supportTicketsService } from "./services";

interface IUseGetTicketsParams {
  currentPage: number;
  products?: string;
  status?: string;
  search?: string;
}

export function useGetTickets({
  currentPage,
  products,
  search,
  status,
}: IUseGetTicketsParams) {
  const context = useApplication();
  const accessToken = context?.accessToken || "";
  const offset = String((currentPage - 1) * 8);

  const { data, isError, isLoading } = useQuery({
    queryKey: [TicketQueryKeys.LIST, offset, products, status, search],
    queryFn: () =>
      supportTicketsService.listTickets({
        offset,
        products,
        token: accessToken,
        status,
        search,
      }),
    refetchOnWindowFocus: false,
  });

  return {
    tickets: data?.tickets || [],
    totalPages: data?.total ? Math.ceil(data?.total / 8) : 1,
    isLoading,
    isError,
  };
}
